import {fetch} from "../../utils/dataAccess";

export function beginMultiShipmentPacking(shipmentId) {
    return new Promise((resolve, reject) => {
        fetch("/shipments/multiPack/" + shipmentId)
            .then(response => {
                resolve(response)
            })
            .catch(error => reject(error))
    })
}

export function specialOrderShipmentIsPackInWMS(shipmentId) {
    return new Promise((resolve, reject) => {
        fetch("/shipments/packInWMS/" + shipmentId)
            .then(response => {
                resolve(response)
            })
            .catch(error => reject(error))
    })
}